import md5 from "md5";

import { pushEnrichedEventToDataLayerWithCleanUp } from "seneca-common/features/analytics";

const namespace = "seneca/authentication";

export function logRequestSignInWithEmailLink({ email }: { email: string }) {
  const emailHash = md5(email);
  return pushEnrichedEventToDataLayerWithCleanUp({
    event: `${namespace}/requestEmailLink`,
    payload: {
      emailHash,
      providerId: "emailLink"
    }
  });
}
